import { useQuery } from '@tanstack/react-query';
import { fetchAvailableProducts } from "./endpoints";
export const useAvailableProducts = (agreementId) => {
    var _a, _b, _c;
    const { data: availableProducts, isLoading: isAvailableProductsLoading, isFetching: isAvailableProductsFetching, isError, error, } = useQuery({
        queryKey: ['available-products', agreementId],
        queryFn: async () => {
            const data = await fetchAvailableProducts(agreementId);
            return data.map(product => ({ value: product.id, name: product.name }));
        },
        enabled: !!agreementId,
    });
    const availableProductsErrorMessage = ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data.message) || ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.title) || '';
    return {
        availableProducts,
        isAvailableProductsLoading,
        isAvailableProductsFetching,
        isError,
        availableProductsErrorMessage,
    };
};
